import { useCallback, useContext, useRef } from 'react';
import {
  createIntl, createIntlCache, IntlContext,
} from 'react-intl';
import AppLocale from '../lngProvider';

const fallbackIntl = createIntl({
  locale: 'en',
  messages: AppLocale.en?.messages || {},
}, createIntlCache());

export const useLocalizedMessage = () => {
  const intl = useContext(IntlContext) || fallbackIntl;
  const currentLocale = intl.locale || 'en';
  const normalizedLocale = currentLocale.split('-')[0];
  const defaultLang = window.DEFAULT_LANGUAGE || 'en';
  const stateRef = useRef({ intl, normalizedLocale, defaultLang });
  stateRef.current = { intl, normalizedLocale, defaultLang };

  return useCallback((id, values) => {
    const {
      intl: currentIntl,
      normalizedLocale: activeLocale,
      defaultLang: fallbackLanguage,
    } = stateRef.current;
    const currentMessages = AppLocale[activeLocale]?.messages || {};
    const defaultMessages = AppLocale[fallbackLanguage]?.messages || {};

    if (currentMessages[id]) {
      return currentIntl.formatMessage({ id }, values);
    }

    if (defaultMessages[id]) {
      // eslint-disable-next-line no-console
      console.warn(`Translation missing for locale "${activeLocale}", using default language "${fallbackLanguage}": ${id}`);
      return currentIntl.formatMessage({ id, defaultMessage: defaultMessages[id] }, values);
    }

    // eslint-disable-next-line no-console
    console.error(`Translation missing for key: ${id}`);
    return id;
  }, []);
};
